import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  ModalFooter,
  Text,
  HStack,
  Tooltip,
  IconButton,
  Select,
  useToast,
  Skeleton,
  SkeletonText,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { addJobCityListAsync, deleteJobCityListAsync, fetchJobCityListAsync, selectJobCity, updateJobCityListAsync } from "../../Address/JobCityList/JobCityListSlice";

function JobCityList() {
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const dispatch = useDispatch();
  const city = useSelector(selectJobCity);
  const toast = useToast();

  const [isLoading, setIsLoading] = useState(true);

  // Fetch jobs whenever the current page changes
  useEffect(() => {
    dispatch(fetchJobCityListAsync())
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));
  }, [dispatch]);

  const [newCity, setnewCity] = useState("");
  const [newStatus, setnewStatus] = useState(""); // Add status state
  const [error, setError] = useState(null);
  const [editCity, seteditCity] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editStatus, seteditStatus] = useState("");
  const [editableCity, seteditableCity] = useState(null);
  const [deletingCity, setdeletingCity] = useState(null);

  const handleDelete = async (uuid) => {
    try {
      await dispatch(deleteJobCityListAsync(uuid));
      dispatch(fetchJobCityListAsync());
      toast({
        title: "City Deleted",
        description: "The city has been successfully deleted.",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      onClose2();
    } catch (error) {
      toast({
        title: "Delete Failed",
        description: "There was an error deleting the city.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  const openDeleteModal = (job) => {
    setdeletingCity(job);
    onOpen2();
  };

  const handleSave = async () => {
    if (!newCity.trim()) {
      toast({
        title: "Validation Error",
        description: "Please enter a city name.",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }

    if (!newStatus) {
      toast({
        title: "Validation Error",
        description: "Please select a status.",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }

    const cityData = {
      title: newCity,
      status: newStatus,
    };

    try {
      await dispatch(addJobCityListAsync(cityData));
      dispatch(fetchJobCityListAsync());
      setnewCity("");
      setnewStatus("");
      setError(null);
      toast({
        title: "City Added",
        description: "The city has been successfully added.",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      onClose1();
    } catch (err) {
      setError(err.message);
      toast({
        title: "Add Failed",
        description: "There was an error adding the city.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  const handleEdit = (cityData) => {
    seteditableCity(cityData);
    seteditCity(cityData.title);
    seteditStatus(cityData.status);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (!editCity.trim()) {
      toast({
        title: "Validation Error",
        description: "Please enter a city name.",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }

    if (!editStatus) {
      toast({
        title: "Validation Error",
        description: "Please select a status.",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }

    try {
      await dispatch(
        updateJobCityListAsync({
          uuid: editableCity.uuid,
          cityData: {
            title: editCity,
            status: editStatus,
          },
        })
      );

      dispatch(fetchJobCityListAsync());
      seteditableCity(null);
      seteditCity("");
      seteditStatus("");
      setError(null);
      toast({
        title: "City Updated",
        description: "The city has been successfully updated.",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      setIsEditModalOpen(false);
    } catch (err) {
      setError(err.message);
      toast({
        title: "Update Failed",
        description: "There was an error updating the city.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  // Skeleton loading component for table rows
  const SkeletonRow = () => (
    <Tr>
      <Td><Skeleton height="20px" width="30px" /></Td>
      <Td><Skeleton height="20px" width="120px" /></Td>
      <Td><Skeleton height="20px" width="80px" /></Td>
      <Td>
        <HStack spacing={2}>
          <Skeleton height="32px" width="32px" borderRadius="md" />
          <Skeleton height="32px" width="32px" borderRadius="md" />
        </HStack>
      </Td>
    </Tr>
  );

  return (
    <div
      className="h-screen bg-adminbg contentAdmin p-4"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className=" pb-2">
        <div className="w-full my-5 bg-white rounded-xl">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Job City List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Add City
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid
                        templateColumns="repeat(2, 1fr)"
                        gap={4}
                        width="100%"
                      >
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>City</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter City"
                              value={newCity}
                              onChange={(e) => setnewCity(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>City Status</FormLabel>
                            <Select
                              placeholder="Select City Status"
                              value={newStatus}
                              onChange={(e) => setnewStatus(e.target.value)}
                              borderColor="black"
                              color="black"
                            >
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </Select>
                          </FormControl>
                        </GridItem>
                      </Grid>
                      {error && <Text color="red.500">{error}</Text>}
                    </VStack>
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button colorScheme="blue" mr={3} onClick={handleSave}>
                      Save
                    </Button>
                    <Button onClick={onClose1}>Cancel</Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                size="4xl"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Edit City
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid
                        templateColumns="repeat(2, 1fr)"
                        gap={4}
                        width="100%"
                      >
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>City</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter City"
                              value={editCity}
                              onChange={(e) => seteditCity(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>City Status</FormLabel>
                            <Select
                              placeholder="Select status"
                              value={editStatus}
                              onChange={(e) => seteditStatus(e.target.value)}
                              borderColor="black"
                              color="black"
                            >
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </Select>
                          </FormControl>
                        </GridItem>
                      </Grid>
                      {error && <Text color="red.500">{error}</Text>}
                    </VStack>
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button colorScheme="blue" mr={3} onClick={handleUpdate}>
                      Update
                    </Button>
                    <Button onClick={() => setIsEditModalOpen(false)}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>

              <Modal isOpen={isOpen2} onClose={onClose2}>
                <ModalOverlay />
                <ModalContent maxW="2xl" borderradius="lg" boxShadow="lg">
                  <ModalHeader
                    fontSize="lg"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Confirm Deletion
                  </ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <Text fontSize="md" textAlign="center">
                      Are you sure you want to delete{" "}
                      <Text as="span" fontWeight="semibold" color="red.500">
                        "{deletingCity?.title}"
                      </Text>
                      ?
                    </Text>
                  </ModalBody>
                  <ModalFooter display="flex" gap="2" justifyContent="center">
                    <Button
                      colorScheme="red"
                      w="40"
                      onClick={() => handleDelete(deletingCity.uuid)}
                    >
                      Delete
                    </Button>
                    <Button
                      variant="outline"
                      colorScheme="red"
                      w="40"
                      onClick={onClose2}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">id</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action </Th>
                </Tr>
              </Thead>
              <Tbody>
                {isLoading ? (
                  // Show skeleton rows while loading
                  Array.from({ length: 5 }).map((_, index) => (
                    <SkeletonRow key={index} />
                  ))
                ) : Array.isArray(city) && city.length > 0 ? (
                  [...city]
                    .sort((a, b) => a.uuid - b.uuid)
                    .map((job, index) => (
                      <Tr key={job.uuid}>
                        <Td>{index + 1}</Td>
                        <Td>{job.title}</Td>
                        <Td textColor={"green"}>{job.status}</Td>
                        <Td>
                          <HStack spacing={2}>
                            <Tooltip label="Edit City" placement="top">
                              <IconButton
                                icon={<EditIcon />}
                                colorScheme="blue"
                                size="sm"
                                onClick={() => handleEdit(job)}
                                aria-label="Edit city"
                              />
                            </Tooltip>
                            <Tooltip label="Delete City" placement="top">
                              <IconButton
                                icon={<DeleteIcon />}
                                colorScheme="red"
                                size="sm"
                                onClick={() => openDeleteModal(job)}
                                aria-label="Delete city"
                              />
                            </Tooltip>
                          </HStack>
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <Tr>
                    <Td colSpan="4" className="text-center py-4 text-gray-500">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default JobCityList;